<div style="text-align: center">
  <h1 style="font-family: Exo, sans-serif;
  font-weight: bold; padding-top: 20px" mat-dialog-title>{{title}}</h1>
  <div mat-dialog-content style="padding-top: 5px" [innerHTML]="body"></div>
  <div mat-dialog-actions style="justify-content: center; padding-top: 40px">
    <button mat-raised-button color="warn" [mat-dialog-close]="choose">Rimuovi</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="">Esci</button>
  </div>
</div>
